import type { LoadRequest, NielsenPluginConfig } from "@foundation-player/api";
import { Media } from "./media_player.types";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the Nielsen plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v2/api/type/load-request/#plugins
 * @see https://docs.player.foundation/v2/api/type/load-request/#foundationpluginnielsen
 * @see https://docs.player.foundation/v2/api/type/nielsen-plugin-config/
 */
export class PluginNielsen extends Plugin {
  public constructor(media: Media) {
    super(media);
  }

  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoadRequestPlugins(): LoadRequest["plugins"] {
    const nielsenPluginConfig: NielsenPluginConfig = {
      enabled: true,
      commentPath: this.media.ivwTopic,
    };
    return {
      "foundation.plugin.nielsen": nielsenPluginConfig,
    };
  }
}
